import { render, staticRenderFns } from "./ReorderProduct.vue?vue&type=template&id=19e526b8&scoped=true&"
import script from "./ReorderProduct.vue?vue&type=script&lang=js&"
export * from "./ReorderProduct.vue?vue&type=script&lang=js&"
import style0 from "./ReorderProduct.vue?vue&type=style&index=0&id=19e526b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19e526b8",
  null
  
)

export default component.exports